function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobalCreate = function SvgGlobalCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 10a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9z",
    style: {
      fill: "#03d47c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.771 12.7a.77.77 0 1 1-1.542 0v-1.929H7.3a.77.77 0 1 1 0-1.542h1.929V7.3a.77.77 0 1 1 1.542 0v1.929H12.7a.77.77 0 1 1 0 1.542h-1.929V12.7z",
    style: {
      fill: "#fcfbf9"
    }
  }));
};
export default SvgGlobalCreate;